import dataServices from "../services/DataServices";
import { error } from "@refinitiv-ui/elements/notification";

const iRPMProj = process.env.REACT_APP_IRPM_PROJ_NAME

const Auth =  {

    loggedIn : false,
    currentUser : null,
    role: "",

    redirectUserLogin() {
      dataServices.go2safe()
    },
    fetchResponse(){
      let uri = window.location.href.split('/');
      if(uri.length>4 && !Auth.loggedIn){
        dataServices.fetchJWT(uri[4],uri[5]).then((data) => {
          // console.log(data["data"])
          if(data["data"]["d"]){
            this.jwt = data["data"]["d"]["jwt"]
            localStorage.setItem('jwt', this.jwt)
            this.extract(this.jwt)
            window.location.href = uri[0]+"//"+uri[2]
          }
        })
      }
    },
    extract(jwt) {
      let parts = jwt.split('.')
      let bodyEnc = parts[1]
      let base64 = bodyEnc.replace(/-/g, '+').replace(/_/g, '/')
      if (!base64) {
        return
      }
      let bodyStr = atob(base64)
      let body
      try {
          body = JSON.parse(bodyStr)
      }
      catch (e) {
        body = {}
      }
      let exp = body.exp
      let user = body.usr
      let role = user.role && user.role[iRPMProj] ? user.role[iRPMProj] : []
      // console.log(role)
      console.log("User logged in:", user)
      if (!this.isExpired(exp)) {
        if(localStorage.getItem('userEmail') && localStorage.getItem('userEmail') !== user.email){
          localStorage.removeItem('userPhoto')
        }
        if(localStorage.getItem('userPhoto') && localStorage.getItem('userPhoto') !== 'null'){
          user.photo = localStorage.getItem('userPhoto')
        }else{
          localStorage.setItem('userEmail', user.email)
          dataServices.sendiRPMRequest('get-user-photo-by-email', {"email":user.email}).then((data) => {
            if(data["status"] === "OK"){
              user.photo = data["data"]["d"]["avatar"]
              localStorage.setItem('userPhoto', user.photo)
            }else{
              user.photo = null
              localStorage.removeItem('userPhoto')
            }
          })
        }
        if (role.includes("Rajc03er9g_[owner]")){
          this.role = "owner"
          this.currentUser = user
          Auth.loggedIn = true
          return true
        }else if (role.includes("admin")){
          this.role = "admin"
          this.currentUser = user
          Auth.loggedIn = true
          return true
        }else if (role.includes("user")){
          this.role = "user"
          this.currentUser = user
          Auth.loggedIn = true
          return true
        }else if (role.length === 0){
          this.role = "new"
          this.currentUser = user
          Auth.loggedIn = true
          return true
        }else{
          Auth.loggedIn = false
        }
      }
      else {
        this.currentUser = null
        Auth.loggedIn = false
        localStorage.removeItem('jwt')
        this.redirectUserLogin()
      }
    },
    isExpired(exp) {
        if (!exp) return true;
        let now = Date.now();
        return now >= exp * 1000;
    },
    login () {
      const regEx = RegExp(/[a-zA-Z0-9]+\.[a-zA-Z0-9]+@(?:lseg|refinitiv)\.com$/gm)
      if (regEx.test(this.$refs.username.value) && this.$refs.password.value === 'isituseful?') {
        Auth.loggedIn = true
        localStorage.setItem(`${this.appName}.lastLoggedIn`, new Date().getTime())
      }
      else {
        error('Invalid username or password')
      }
    },
    logout() {
        Auth.loggedIn = false;
        localStorage.removeItem('jwt');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userPhoto');
    },
    checkLogin () {
      const jwt = localStorage.getItem('jwt')
      // console.log(jwt)
      if (jwt == null) {
        let uri = window.location.href.split('/');
        if(uri.length>4){
          this.fetchResponse()
        }else{
          this.redirectUserLogin()
        }
      }else{
        this.extract(jwt)
      }
    },
    getUserId(){
      const jwt = localStorage.getItem('jwt');
      let parts = jwt.split('.')
      let bodyEnc = parts[1]
      let base64 = bodyEnc.replace(/-/g, '+').replace(/_/g, '/')
      if (!base64) {
        return
      }
      let bodyStr = atob(base64)
      let body
      try {
          body = JSON.parse(bodyStr)
      }
      catch (e) {
        body = {}
      }
      let user = body.usr
      return user.trid
    }
}

export default Auth;

